export default "__VITE_PUBLIC_ASSET__4e972a60__"